const OfferLineBreakdown = {
  paid_and_free: '{{paidQuantity}} × {{price}} płatne · {{freeQuantity}} × gratis',
  all_free: '{{freeQuantity}} × gratis',
};

export default OfferLineBreakdown;
